import moment from "moment";
import { ISearchLimitOffset } from "./ISearchLimitOffset";

export interface IFilterCompteBO extends ISearchLimitOffset {
    Id?: number | null;
    NomPrenom?: string;
    Email?: string;
    DateDebut?: Date;
    DateFin?: Date;
    IdStatusUtilisateur?: string;
    IdTypeUtilisateur?: string;
    RaisonSociale?: string;
    Siren?: string;
    SortField?: string;
    IsDescending?:boolean;
  }

  export interface IFilterCompteBODTO extends ISearchLimitOffset {
    Id: number | null,
    NomPrenom: string,
    Email: string,
    DateDebut: string,
    DateFin: string,
    IdStatusUtilisateur: string,
    IdTypeUtilisateur: string,
    RaisonSociale: string;
    Siren: string;
    SortField: string,
    IsDescending:boolean
}
  
  export const getDefaultFilterCompte = (): IFilterCompteBO => ({
    Id: null,
    NomPrenom: undefined,
    Email: undefined,
    IdStatusUtilisateur: undefined,
    IdTypeUtilisateur: undefined,
    DateDebut: undefined,
    DateFin: undefined,
    RaisonSociale: undefined,
    Siren: undefined,
    Limit: 10,
    Offset: 0,
    SortField: "Nom",
    IsDescending: true
  });

  export const dtoToFilter = (dto: IFilterCompteBODTO): IFilterCompteBO => {
  
    return {
        Id: dto.Id,
        NomPrenom: dto.NomPrenom,
        Email: dto.Email,
        IdStatusUtilisateur: dto.IdStatusUtilisateur,
        IdTypeUtilisateur: dto.IdTypeUtilisateur,
        DateDebut: dto.DateDebut ? new Date(dto.DateDebut) : undefined,
        DateFin: dto.DateFin ? new Date(dto.DateFin) : undefined,
        RaisonSociale: dto.RaisonSociale,
        Siren: dto.Siren,
        Limit: dto.Limit !== undefined ? dto.Limit : 10,
        Offset: dto.Offset !== undefined ? dto.Offset : 0,
    };
  };

  export const filterToQuery = (filter: IFilterCompteBO): IFilterCompteBODTO => {
    const dto: IFilterCompteBODTO = {
        Id: null,
        NomPrenom: "",
        Email: "",
        DateDebut: "",
        DateFin: "",
        IdStatusUtilisateur: "",
        IdTypeUtilisateur: "",
        RaisonSociale:"",
        Siren:"",
        SortField: "",
        IsDescending: false
    };
 
    if (filter?.Id !== undefined ) {
      dto.Id = filter.Id;
    } 

    if (filter?.NomPrenom !== undefined ) {
      dto.NomPrenom = filter.NomPrenom;
    } 

    if (filter?.Email !== undefined ) {
      dto.Email = filter.Email;
    } 

    if (filter?.IdStatusUtilisateur !== undefined ) {
      dto.IdStatusUtilisateur = filter.IdStatusUtilisateur;
    } 

    if (filter?.IdTypeUtilisateur !== undefined ) {
        dto.IdTypeUtilisateur = filter.IdTypeUtilisateur;
    } 

    if (filter.DateDebut) {
        if (filter.DateDebut instanceof Date) {
            // Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
            dto.DateDebut = moment(new Date(filter.DateDebut?.getFullYear(),filter.DateDebut?.getMonth(),filter.DateDebut?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        } else {
            dto.DateDebut = filter.DateDebut;
        }
        
    }
    if (filter.DateFin) {
        if (filter.DateFin instanceof Date) {
            //Supprimer l'utilisation de toISOString car elle retourne la date avec l'heure en format UTC.
            dto.DateFin = moment(new Date(filter.DateFin?.getFullYear(),filter.DateFin?.getMonth(),filter.DateFin?.getDate(),0,0,0)).format("YYYY-MM-DDTHH:mm:ss.sssZ");
        } else {
            dto.DateFin = filter.DateFin;
        }
    }

    if (filter?.RaisonSociale !== undefined ) {
      dto.RaisonSociale = filter.RaisonSociale;
    } 
    if (filter?.Siren !== undefined ) {
      dto.Siren = filter.Siren;
    } 
    if (filter?.Limit) {
      dto.Limit = filter.Limit;
    } else {
      dto.Limit = 10;
    }
    if (filter?.Offset) {
      dto.Offset = filter.Offset;
    } else {
      dto.Offset = 0;
    }
  
    if (filter?.IsDescending) {
      dto.IsDescending = filter.IsDescending;
    } else {
      dto.IsDescending = false;
    }
  
    if (filter?.SortField) {
      dto.SortField = filter.SortField;
    } else {
      dto.SortField = "";
    }

    localStorage.setItem("IFilterComptesBO", JSON.stringify(dto));
  
    return dto;
  };